module.exports = __webpack_public_path__ + "static/media/bg_login.a248d6b4.png";